module.exports = __webpack_public_path__ + "img/21.62e4b669.png";